import { state } from "../context/store";
function resetAllDesigns() {
  console.log("New Design");
  state.optionPage = 0;
  state.current.currentStep = 0;
  // state.initialChoices = {
  //   activeSeat: null,
  //   threeDModel: "null",
  //   type: { index: null, name: "Select your Bike Type" },
  //   make: { index: null, name: "Select your Bike Type First" },
  //   model: { index: null, name: "Select your Make First" },
  //   year: { index: null, name: "Select your Model First" },
  //   inhouseCode: null,
  //   logoSize: null,
  //   ribLimit: 6,
  // };
  state.current.choices.topPanel.selected = {
    name: "White",
    hex: "#ddd",
    src: null,
    abrv: "WHT",
  };
  state.current.choices.sidePanels.selected = {
    mode: "regular",
    name: "White",
    hex: "#ddd",
    abrv: "WHT",
  };
  state.current.choices.ribs.selected = {
    mode: "no",
    rib: [
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
      { name: "White", hex: "#ddd", src: null, abrv: "WHT" },
    ],
  };
  state.current.choices.sideLogos.selected = {
    mode: "enjoy",
    name: "EnjoyMfg",
  };
  state.current.choices.topLogo.selected = { mode: "enjoy", name: "EnjoyMfg" };
  state.current.choices.sealant.selected = {
    mode: "no",
    name: "No Sealant",
  };
  state.current.choices.raceNumber.selected = {
    mode: "none",
    name: "white",
    outlineName: "black",
    number: "",
    hex: "#f5f5f5",
    outlineHex: "#111111",
    font: "old-english.ttf",
  };
  state.current.status.termsChecked = false;
  state.current.status.terms2Checked = false;
  state.current.status.confirmResetModel = false;

  // state.modalResetCustomisationOpen = false
  // state.confirmRepick = false
  // state.settingModelType = true
  // state.sidePanelMode = 'regular'
  // state.currentRibAmount = null
  // state.ribColorMode = 'single'
  // state.sealantMode = 'no'

  // state.current.settingModel = true
  // state.modalResetCustomisationOpen = false
  // state.confirmReset = false
  // state.modalOpen = false
  // state.cameraControls.position = [3.5, 1, 1]
  // state.cameraControls.target = [0, 0, 0]
}

export default resetAllDesigns;
